'use client';

import { ProgressBar as HeroProgressBar } from '@heroui/react';
import { ReactNode } from 'react';

export interface ProgressBarProps {
  children?: ReactNode;
  value?: number;
  minValue?: number;
  maxValue?: number;
  isIndeterminate?: boolean;
  size?: 'sm' | 'md' | 'lg';
  color?: 'default' | 'accent' | 'success' | 'warning' | 'danger';
  'aria-label'?: string;
}

const ProgressBarRoot = ({
  children,
  value,
  minValue,
  maxValue,
  isIndeterminate,
  size,
  color,
  'aria-label': ariaLabel,
}: ProgressBarProps) => {
  return (
    <HeroProgressBar
      value={value}
      minValue={minValue}
      maxValue={maxValue}
      isIndeterminate={isIndeterminate}
      size={size}
      color={color}
      aria-label={ariaLabel}
    >
      {children}
    </HeroProgressBar>
  );
};

const Track = ({ children }: { children: ReactNode }) => (
  <HeroProgressBar.Track>{children}</HeroProgressBar.Track>
);

const Fill = () => <HeroProgressBar.Fill />;

const Output = () => <HeroProgressBar.Output />;

export const ProgressBar = Object.assign(ProgressBarRoot, {
  Track,
  Fill,
  Output,
});
